<template>
  <ul class="search-results">
    <li v-for="result in props.results" :key="result.id.raw" :class="props.displayClass">
      <SearchResult :search-input-value="props.searchInputValue" :result="result" @linkClicked="handleClick" />
    </li>
  </ul>
</template>

<script setup>
import SearchResult from "./SearchResult.vue";

const emit = defineEmits(['linkClicked'])

const handleClick = (event) => {
  emit('linkClicked', event)
}

const props = defineProps({
  results: {
    type: Array,
    required: true
  },
  displayClass: {
    type: String,
    required: true
  },
  searchInputValue: {
    type: String,
    required: true
  }
})
</script>